$(function () {
    pickupOrder()
});



function pickupOrder(){
    $(".checkbox_1").change(function() {
        if(this.checked) {
            $('#store_list_wrapper').removeClass('d-none');
            $('.store_list_wrapper').addClass('d-flex');
            $('#store_list').removeClass('d-none');
            $('.radio_ritiro').attr("required","true");
        }
        else
        {
            $('#store_list_wrapper').addClass('d-none');
            $('.store_list_wrapper').removeClass('d-flex');
            $('#store_list').addClass('d-none');
            $('.radio_ritiro').removeAttr("required");
        }
    });



}